import React from 'react';
import { ArrowRightIcon, AwardIcon, StarIcon } from 'lucide-react';
export function FeaturedRecognitionSection() {
  return <section className="py-32 bg-[#020202] relative overflow-hidden border-y border-white/5" data-id="element-81">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[60rem] h-[30rem] bg-[#D4AF37]/5 rounded-[100%] blur-[120px] pointer-events-none" data-id="element-82" />

      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10" data-id="element-83">
        <div className="text-center max-w-3xl mx-auto mb-20" data-id="element-84">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/5 border border-white/10 mb-6" data-id="element-85">
            <AwardIcon className="w-4 h-4 text-[#D4AF37]" data-id="element-86" />
            <span className="text-xs font-bold text-gray-300 uppercase tracking-widest" data-id="element-87">
              Industry Recognition
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold mb-6 tracking-tight" data-id="element-88">
            Recognized by the best in the Shopify ecosystem.
          </h2>
          <p className="text-xl text-gray-400" data-id="element-89">
            Our commitment to engineering excellence and conversion-driven
            design has earned us features from leading ecommerce platforms.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-90">
          {/* Omnisend Feature */}
          <a href="https://www.omnisend.com/blog/shopify-experts/" target="_blank" rel="noopener noreferrer" className="group relative rounded-3xl bg-white/[0.02] border border-white/10 p-10 hover:bg-white/[0.04] hover:border-white/20 transition-all duration-500 overflow-hidden flex flex-col h-full" data-id="element-91">
            <div className="absolute top-0 right-0 w-64 h-64 bg-emerald-500/10 rounded-full blur-[80px] opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" data-id="element-92" />

            <div className="mb-8" data-id="element-93">
              <img src="https://cdn.magicpatterns.com/uploads/tEKY1KVFn8NPQae4HonbJW/omnisend-logo.png" alt="Omnisend" className="h-8 object-contain opacity-70 group-hover:opacity-100 transition-opacity" onError={e => {
              // Fallback if logo fails
              e.currentTarget.style.display = 'none';
              e.currentTarget.nextElementSibling?.classList.remove('hidden');
            }} data-id="element-94" />
              <span className="hidden text-2xl font-bold text-white tracking-tight" data-id="element-95">
                Omnisend
              </span>
            </div>

            <h3 className="text-2xl font-bold text-white mb-4 leading-snug" data-id="element-96">
              "Top Shopify Experts for Ecommerce Development"
            </h3>

            <p className="text-gray-400 text-lg mb-10 flex-grow leading-relaxed" data-id="element-97">
              Recognized among the industry's elite Shopify experts for
              exceptional store development, custom design, and technical
              expertise.
            </p>

            <div className="flex items-center gap-2 text-emerald-400 font-semibold mt-auto" data-id="element-98">
              Read the feature{' '}
              <ArrowRightIcon className="w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-99" />
            </div>
          </a>

          {/* EComposer Feature */}
          <a href="https://ecomposer.io/blogs/ecommerce/best-shopify-web-designers" target="_blank" rel="noopener noreferrer" className="group relative rounded-3xl bg-white/[0.02] border border-white/10 p-10 hover:bg-white/[0.04] hover:border-white/20 transition-all duration-500 overflow-hidden flex flex-col h-full" data-id="element-100">
            <div className="absolute top-0 right-0 w-64 h-64 bg-blue-500/10 rounded-full blur-[80px] opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" data-id="element-101" />

            <div className="mb-8" data-id="element-102">
              <img src="https://cdn.magicpatterns.com/uploads/tEKY1KVFn8NPQae4HonbJW/ecomposer-logo.png" alt="EComposer" className="h-8 object-contain opacity-70 group-hover:opacity-100 transition-opacity" onError={e => {
              e.currentTarget.style.display = 'none';
              e.currentTarget.nextElementSibling?.classList.remove('hidden');
            }} data-id="element-103" />
              <span className="hidden text-2xl font-bold text-white tracking-tight" data-id="element-104">
                EComposer
              </span>
            </div>

            <h3 className="text-2xl font-bold text-white mb-4 leading-snug" data-id="element-105">
              "Best Shopify Web Designers"
            </h3>

            <p className="text-gray-400 text-lg mb-10 flex-grow leading-relaxed" data-id="element-106">
              Listed among the best Shopify web designers globally for creating
              high-converting, beautifully engineered storefronts.
            </p>

            <div className="flex items-center gap-2 text-blue-400 font-semibold mt-auto" data-id="element-107">
              Read the feature{' '}
              <ArrowRightIcon className="w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-108" />
            </div>
          </a>
        </div>
      </div>
    </section>;
}